import { DatePicker, Segmented } from 'antd';
import dayjs from 'dayjs';
import { CalendarDays } from 'lucide-react';

import { useI18n } from '../../i18n';
import { DATE_FORMAT, DATE_PRESETS, getPresetRange, isFutureDate } from '../../utils';

const DISPLAY_FORMAT = 'DD.MM.YYYY';

export const DateRangeFilter = ({ value, onChange, presets = DATE_PRESETS }) => {
  const { t } = useI18n();
  const { preset, range } = value;

  const options = presets.map(key => ({ value: key, label: t(`filters.${key}`) }));
  if (preset === 'custom') options.push({ value: 'custom', label: t('filters.custom') });

  return (
    <>
      <div className='wm-filter-bar__presets'>
        <Segmented
          options={options}
          value={preset}
          onChange={next => {
            if (next !== 'custom') onChange({ preset: next, range: getPresetRange(next) });
          }}
        />
      </div>
      <DatePicker.RangePicker
        value={[dayjs(range[0]), dayjs(range[1])]}
        format={DISPLAY_FORMAT}
        allowClear={false}
        disabledDate={isFutureDate}
        suffixIcon={<CalendarDays size={15} strokeWidth={1.75} />}
        placeholder={[t('filters.startDate'), t('filters.endDate')]}
        presets={presets.map(key => ({
          label: t(`filters.${key}`),
          value: getPresetRange(key).map(d => dayjs(d)),
        }))}
        onChange={dates => {
          if (!dates?.[0] || !dates?.[1] || isFutureDate(dates[1])) return;
          const next = [dates[0].format(DATE_FORMAT), dates[1].format(DATE_FORMAT)];
          const matched = presets.find(key => {
            const r = getPresetRange(key);
            return r[0] === next[0] && r[1] === next[1];
          });
          onChange({ preset: matched ?? 'custom', range: next });
        }}
        style={{ width: 260 }}
        placement='bottomLeft'
      />
    </>
  );
};
